export const POST_WALLET_REGISTRATION_SUCCESS = 'POST_WALLET_REGISTRATION_SUCCESS';
export const postWalletRegistrationSuccess = (fulfillmentPlanIdsAndShipFromIds) => {
  return {
    type: POST_WALLET_REGISTRATION_SUCCESS,
    fulfillmentPlanIdsAndShipFromIds,
  };
};
